<span *ngIf="question.prompts.length>0">
<app-do-prompt
*ngFor="let prompt of question.prompts"
[prompt]="prompt"
[quizEnvelop]="quizEnvelop"
[questionIndex]="questionIndex"
[isLastQuestion]="isLastQuestion"
[answerGiven]="answerGiven">
</app-do-prompt>
</span>
<div class="navcard row mt-4" *ngIf="question.server_question_id!=0">
    <div class="col-sm-12 text-center">
    <button *ngIf ="questionIndex==0" class="btn btn-secondary btn-lg me-3"><i class="fa fa-angle-double-left"></i> Back</button>
    <button *ngIf="questionIndex!=0"
        type="button"
        (click)="onPreviousQuestion()"
        class="backnav btn btn-primary btn-lg me-3"><i
        class="fa fa-angle-double-left"></i> Previous Question
    </button>
    <button *ngIf="!(questionIndex+1 == quizEnvelop.questions.length)"
        type="button"
        (click)="onNextQuestion()"
        class="forwardnav btn btn-primary btn-lg">Next Question <i class="fa fa-angle-double-right"></i>
    </button>

    <button *ngIf="!quizEnvelop.isCompleted && (isLastQuestion)"
        type="button"
        (click)="onSaveForMarking()"
        class="save btn btn-primary  btn-lg" > Save For Marking
    </button>
</div>
</div>
